import { Box, Center, Flex } from '@chakra-ui/react';
import React from 'react';

import { WLH1 } from '../../../design-library';

interface FalconCamProps {}

const FalconCam: React.FC<FalconCamProps> = () => {
  return (
    <Flex
      as="section"
      direction="column"
      width="full"
      height="auto"
      marginTop={4}
      marginBottom={4}
    >
      <Center
        width="full"
        paddingY={8}
        paddingX={2}
        backgroundColor="red.800"
        color="white"
        textAlign="center"
      >
        <WLH1 marginBlockEnd={0}>
          LIVE WoodmenLife Peregrine Falcon Cameras
        </WLH1>
      </Center>

      <Box width="full" paddingY={3} backgroundColor="black" height="auto">
        <Box
          marginY={0}
          marginX="auto"
          width={['100%', null, '75%']}
          height="auto"
        >
          {/* This DIV is extracted from the EarthCam script that the legacy site loads */}
          {/* React doesn't allow use of `document.write` in external scripts so we have to do this workaround /* }
          { /* The alternative is to use nested IFRAMEs that appear to break the live player */}
          <div
            className="earthcam-embed-container"
            style={{
              position: 'relative',
              paddingBottom: '56.25%',
              overflow: 'auto',
              boxSizing: 'content-box',
            }}
          >
            <iframe
              title="WoodmenLife Falcon Cam"
              className="iframe"
              width="800"
              height="450"
              allowFullScreen
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                opacity: 1,
                width: '100%',
                height: '100%',
                margin: 0,
                visibility: 'visible',
                overflow: 'hidden',
                border: 'none',
              }}
              src="https://share.earthcam.net/tJ90CoLmq7TzrY396Yd88GhHTv5_MegZ0qLn7bWl2_Q!"
            />
          </div>
        </Box>
      </Box>
    </Flex>
  );
};

export default FalconCam;
